function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9 8.273A.728.728 0 008.273 9v2.909a.727.727 0 101.455 0V9A.728.728 0 009 8.273zM9 1a8 8 0 108 8 8.009 8.009 0 00-8-8zm0 14.545A6.545 6.545 0 1115.545 9 6.553 6.553 0 019 15.545zm.007-10.181H9a.731.731 0 10.007 0z",
  fill: "#2196f3"
});

var SvgIconInfoMark = function SvgIconInfoMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4Ij48ZGVmcz48c3R5bGU+LmEsLmJ7ZmlsbDojMjE5NmYzO30uYXtvcGFjaXR5OjA7fTwvc3R5bGU+PC9kZWZzPjxyZWN0IGNsYXNzPSJhIiB3aWR0aD0iMTgiIGhlaWdodD0iMTgiLz48cGF0aCBjbGFzcz0iYiIgZD0iTTksOC4yNzNBLjcyOC43MjgsMCwwLDAsOC4yNzMsOXYyLjkwOWEuNzI3LjcyNywwLDEsMCwxLjQ1NSwwVjlBLjcyOC43MjgsMCwwLDAsOSw4LjI3M1pNOSwxYTgsOCwwLDEsMCw4LDhBOC4wMDksOC4wMDksMCwwLDAsOSwxWk05LDE1LjU0NUE2LjU0NSw2LjU0NSwwLDEsMSwxNS41NDUsOSw2LjU1Myw2LjU1MywwLDAsMSw5LDE1LjU0NVpNOS4wMDcsNS4zNjRIOWEuNzMxLjczMSwwLDEsMCwuMDA3LDBaIi8+PC9zdmc+";
export { SvgIconInfoMark as ReactComponent };